import variables from '../config/variables';
import Auth from '../Auth/Auth';

const auth = new Auth();

if(variables.apiUrl.charAt(variables.apiUrl.length - 1) !== '/') variables.apiUrl += '/';

function requestApi(url, method, json) {
  return new Promise(function(resolve, reject) {
    if(!auth.isAuthenticated()) return reject('User not authentified.');
    if(!method) method = 'GET';
    if(!json) json = {};

    const token = localStorage.getItem('id_token');

    let request = {
      method: method.toUpperCase(),
      headers: new Headers({
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      })
    };

    if(request.method !== 'GET' && request.method !== 'HEAD') {
      request.body = JSON.stringify(json);
    }

    fetch(variables.apiUrl + url, request)
      .then(response => {
        resolve(response.json())
      })
      .catch(error => {
        return error
      });
  });
}

export default {
  request: requestApi
}


// WEBPACK FOOTER //
// ./src/Util/API.js